module.exports = __webpack_public_path__ + "img/contenedor22.928b8da8.png";